// The code in this file will load on every page of your site
import wixSite from 'wix-site';
// ...

$w.onReady(function () {

	// Write your code here
});